// Default values work on localhost:3000 and foomedical.com
// Replace these values with your own values for production
export const MEDPLUM_PROJECT_ID = import.meta.env.VITE_MEDPLUM_PROJECT_ID;
export const MEDPLUM_CLIENT_ID = import.meta.env.VITE_MEDPLUM_CLIENT_ID;
export const MEDPLUM_GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const MEDPLUM_RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
